module.exports = __webpack_public_path__ + "img/glassthicknessminus-16.97712c54.svg";